import 'is-in-viewport';
import {$dateCarousel, closePropertyInfo} from "./modules/carousel";

let didScroll = false;
let didResize = false;
let windowHeight;

const transitionSelectors = '.move-up-in-viewport, .move-down-in-viewport, .move-left-in-viewport, .move-right-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport, .full-width-in-viewport, .tile-in-viewport, .bounce-up-in-viewport';
const $animatedBackground = $( '#animated-background' );

let propertyInfoTimer = null;

$( function() {
	windowHeight = $( window ).height();

	animateInViewport();
	updateStyle();
} );

$( window ).resize( function() {
	windowHeight = $( window ).height();
} );

$( window ).scroll( function() {
	didScroll = true;
} );

setInterval( function() {
	if ( didScroll ) {
		didScroll = false;
		animateInViewport();
		updateStyle();
	}
}, 100 );

function updateStyle() {
	const $blocks = $( '[class*="styled-block"]' );

	let tallest = {
		element: null,
		height: 0,
	};

	$blocks.each( function() {
		const $this = $( this );
		const height = getHeightInViewport( $this );

		if ( height > tallest.height ) {
			tallest = {
				element: $this,
				height,
			};
		}
	} );

	if ( tallest.element ) {
		if ( tallest.element.attr( 'data-style' ) ) {
			$( '#site-header, #content' ).removeClass( function( index, className ) {
				return (className.match( /(^|\s)style-\S+/g ) || []).join( ' ' );
			} ).addClass( 'style-' + tallest.element.attr( 'data-style' ) );

			if ( tallest.element.attr( 'data-animated-background' ) ) {
				$animatedBackground.removeClass( 'opacity-0' );
			} else {
				$animatedBackground.addClass( 'opacity-0' );
			}

			// Timeline
			let dotIndex = tallest.element.attr( 'data-page-dot' );
			if ( dotIndex ) {
				let $pageDots = tallest.element.parents( '.content-block' ).find( '.flickity-page-dots-vertical' );
				$pageDots.find( '.dot' ).removeClass( 'is-selected' );
				$pageDots.find( '.dot' ).eq( dotIndex ).addClass( 'is-selected' );

				var nextId = tallest.element.next().attr( 'id' );
				if ( nextId ) {
					$( '.event-scroll-arrow' ).attr( 'href', '#' + nextId );
				} else {
					$( '.event-scroll-arrow' ).attr( 'href', 'javascript:;' );
				}

				$dateCarousel.flickity( 'select', dotIndex );
			}

			if ( tallest.element.hasClass( 'last-event' ) || tallest.element.prevAll( '.block-timeline' ).length ) {
				$( '.event-scroll-arrow' ).addClass( 'opacity-0' ).removeClass( 'pointer-events-auto' );
			} else {
				$( '.event-scroll-arrow' ).removeClass( 'opacity-0' ).addClass( 'pointer-events-auto' );
			}
		}

		if ( !tallest.element.hasClass( 'block-properties' ) ) {
			clearTimeout( propertyInfoTimer );

			propertyInfoTimer = setTimeout( function() {
				closePropertyInfo();
			}, 1000 );
		} else {
			clearTimeout( propertyInfoTimer );
			propertyInfoTimer = null;
		}
	}
}

export function animateInViewport() {
	$( transitionSelectors ).each( function() {
		var $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}

function getHeightInViewport( $el ) {
	var elementHeight = $el.outerHeight(),
		H = windowHeight,
		r = $el[ 0 ].getBoundingClientRect(),
		t = r.top,
		b = r.bottom;
	return Math.max( 0, t > 0 ? Math.min( elementHeight, H - t ) : Math.min( b, H ) );
}
